import React, { memo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import cx from "classnames";
import { map } from "lodash";
import propTypes from "prop-types";

import SideDrawerListItem from "./sideDrawerListItem/SideDrawerListItem";
import PopUp from "../popUp";
import { ICONS } from "../../constants/icons.constants";
import { ROUTES } from "../../constants/routes.constants";
import playlistStore from "../../zustand/playlist.store";
import logo from "../../assets/Logo.png";
import { playlistHelpers } from "../../helpers";

import styles from "./sideDrawer.module.scss";
// import LoadingSkeleton from "../loadingSkeleton/LoadingSkeleton";

// Player routes that require active subscription
const RESTRICTED_ROUTES = [
  ROUTES.HOME,
  ROUTES.MY_SCHEDULE,
  ROUTES.LIKED,
  ROUTES.ARTIST,
  ROUTES.MY_PLAYLIST,
];

const SideDrawer = ({ restrictedMode = false }) => {
  const { playlists } = playlistStore((state) => state);
  const [showRestrictedPopup, setShowRestrictedPopup] = useState(false);

  const navigate = useNavigate();
  const currentLocation = useLocation();

  const isRouteRestricted = (route) => {
    return restrictedMode && RESTRICTED_ROUTES.includes(route);
  };

  const handleRestrictedClick = (route) => {
    if (isRouteRestricted(route)) {
      setShowRestrictedPopup(true);
      return true;
    }
    return false;
  };

  const onPlayListClick = (id) => () => {
    if (restrictedMode) {
      setShowRestrictedPopup(true);
      return;
    }
    navigate(`/my-playlist/view/${id}`);
  };

  const handleGoToPlans = () => {
    setShowRestrictedPopup(false);
    navigate(ROUTES.PROFILE, { state: { openTab: "plans" } });
  };

  return (
    <div className={styles.dashboard}>
      <div className={styles.header}>
        {/* <Icons type={ICONS.MAIN_LOGO} /> */}
        <img src={logo} alt="logo" className={styles.logo} />
      </div>
      <SideDrawerListItem 
        icon={ICONS.HOME} 
        title="Home" 
        route={ROUTES.HOME}
        disabled={isRouteRestricted(ROUTES.HOME)}
        onRestrictedClick={() => handleRestrictedClick(ROUTES.HOME)}
      />
      <SideDrawerListItem
        icon={ICONS.MY_SCHEDULE}
        title="My Schedule"
        route={ROUTES.MY_SCHEDULE}
        disabled={isRouteRestricted(ROUTES.MY_SCHEDULE)}
        onRestrictedClick={() => handleRestrictedClick(ROUTES.MY_SCHEDULE)}
      />
      <SideDrawerListItem
        icon={ICONS.LIKE_NAVBAR}
        title="Liked"
        route={ROUTES.LIKED}
        disabled={isRouteRestricted(ROUTES.LIKED)}
        onRestrictedClick={() => handleRestrictedClick(ROUTES.LIKED)}
      />

      <SideDrawerListItem
        icon={ICONS.ARTIST_PROFILE}
        title="Artist"
        route={ROUTES.ARTIST}
        disabled={isRouteRestricted(ROUTES.ARTIST)}
        onRestrictedClick={() => handleRestrictedClick(ROUTES.ARTIST)}
      />
      <SideDrawerListItem
        icon={ICONS.MY_PLAYLIST}
        title="My Playlist"
        route={ROUTES.MY_PLAYLIST}
        disabled={isRouteRestricted(ROUTES.MY_PLAYLIST)}
        onRestrictedClick={() => handleRestrictedClick(ROUTES.MY_PLAYLIST)}
      />

      <div className={styles.playlist}>
        {
          // !isLoading ? (
          map(playlistHelpers.rearrangeLiked(playlists), ({ name, id }) => (
            <div className={styles.playlistTextContainer} key={id}>
              <div
                onClick={onPlayListClick(id)}
                className={cx(styles.playlistText, {
                  [styles.active]:
                    `/my-playlist/view/${id}` === currentLocation.pathname,
                  [styles.disabled]: restrictedMode,
                })}
              >
                {name}
              </div>
              {/* tooltip */}
              <div className={styles.customTooltip}>{name}</div>
            </div>
          ))
          // ) : (
          //   <>
          //     <LoadingSkeleton isPlaylist />
          //     <LoadingSkeleton isPlaylist />
          //     <LoadingSkeleton isPlaylist />
          //     <LoadingSkeleton isPlaylist />
          //   </>
          // )
        }
      </div>
      <div className={styles.profileIcon}>
        <SideDrawerListItem
          icon={ICONS.PROFILE}
          title="Profile"
          route={ROUTES.PROFILE}
        />
      </div>

      {/* Subscription Required Popup */}
      <PopUp
        isOpen={showRestrictedPopup}
        setIsOpen={setShowRestrictedPopup}
        title="Your subscription needs attention. Please update your billing to continue using the player."
        iconType={ICONS.ERROR}
        btnPlaceholder="View Plans"
        isBtnVisible={true}
        onSuccess={handleGoToPlans}
        onCancle={() => setShowRestrictedPopup(false)}
      />
    </div>
  );
};

SideDrawer.propTypes = {
  restrictedMode: propTypes.bool,
};

SideDrawer.defaultProps = {
  restrictedMode: false,
};

// SideDrawer.propTypes = {
//   username: propTypes.string,
//   children: propTypes.element,
// };

// SideDrawer.defaultProps = {
//   username: '',
//   children: <></>,
// };

export default memo(SideDrawer);
